module.exports = __webpack_public_path__ + "img/00015.a14e8eb3.webp";